/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "pgotnnhskwqldcfobyiq"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBnb3Rubmhza3dxbGRjZm9ieWlxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjcyODgzNTMsImV4cCI6MjA4Mjg2NDM1M30.V-f6xLUh5BLyLMRBiD4_SglWpeVsBe9sDuh2g14tikw"